// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"1d5dfa29","453":"1e3ca2a7","603":"2dbe5a6a"}[chunkId] + ".chunk.js";
};